import { useEffect, useState, type ReactNode } from "react";
import { LoginScreen } from "./LoginScreen";
import { fetchAuthMode, isAuthenticated, type AuthMode } from "../auth/webAuth";

/**
 * Sign-in gate for the standalone web pages (`/authtoken`, `/exceldata`):
 * renders the normal LoginScreen until there is a session, then `children`
 * with the site's sign-in mode. Nothing inside mounts before that, so no page
 * fetch fires unauthenticated. Under mode "none" there is nothing to sign in to.
 */
export function WebSignInGate({ children }: { children: (mode: AuthMode) => ReactNode }) {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(false);
  const [mode, setMode] = useState<AuthMode>("none");

  useEffect(() => {
    (async () => {
      const m = await fetchAuthMode();
      setMode(m);
      setAuthed(m === "none" ? true : await isAuthenticated());
      setReady(true);
    })();
  }, []);

  if (!ready) return null;
  if (!authed) return <LoginScreen mode={mode} onAuthed={() => setAuthed(true)} />;
  return <>{children(mode)}</>;
}
